import { PatientPresence } from '@dreryk/egabinet-appointment-frontend-api';

import { createSingleInterpolatedTranslationKey, TranslatableText, useTranslate } from '@dreryk/react-common';

import { appointmentsTranslationKeys } from '../../../../translations';
import { getPatientPresenceFilterCount } from '../../AppointmentsFilterPanel/fields/PatientPresenceField/PatientPresenceField.utils';

const FILTER_SEPARATOR = ', ';

export const usePatientPresenceFilterLabel = (patientPresences: PatientPresence[]): TranslatableText => {
   const translate = useTranslate();

   if (patientPresences.length === getPatientPresenceFilterCount()) {
      return createSingleInterpolatedTranslationKey(
         appointmentsTranslationKeys.patientPresenceStatusFilter.filterLabel,
         'patientPresences',
         translate(appointmentsTranslationKeys.patientPresenceStatusFilter.filterLabelAll)
      );
   }

   return createSingleInterpolatedTranslationKey(
      appointmentsTranslationKeys.patientPresenceStatusFilter.filterLabel,
      'patientPresences',
      patientPresences
         .map((patientPresence) => translate(appointmentsTranslationKeys.patientPresenceMap[patientPresence]))
         .join(FILTER_SEPARATOR)
   );
};
